export default function reloadAndOpenCart() {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set("uso-open-cart", true);
  window.location.search = searchParams.toString();
}
